import {
  OttTaboolaProgramItemWidgetContainer,
  OttTaboolaWrap,
} from './OttTaboola.style'
import {
  PocTaboolaPageType,
  PocTaboolaSuffixId,
  Taboola,
} from '../../components/Taboola'
import React, { useEffect } from 'react'
import { isDesktop } from '../../client'

export const OttTaboolaFeed = ({
  suffixId,
}: {
  suffixId: PocTaboolaSuffixId
}) => {
  return (
    <OttTaboolaWrap>
      <Taboola
        key={'taboolaFeed'}
        pageType={PocTaboolaPageType.vod}
        suffixId={suffixId}
      />
    </OttTaboolaWrap>
  )
}

export const OttTaboolaMidPageWidget = ({ counter }: { counter: number }) => {
  return (
    <OttTaboolaWrap data-counter={counter}>
      <Taboola
        pageType={PocTaboolaPageType.ott}
        suffixId={PocTaboolaSuffixId.ottMidPageWidget}
        index={counter}
      />
    </OttTaboolaWrap>
  )
}
export const OttTaboolaMidSeriesWidget = ({ counter }: { counter: number }) => {
  return (
    <OttTaboolaWrap theme={'SeriesWidget'} data-counter={counter}>
      <Taboola
        pageType={PocTaboolaPageType.ott}
        suffixId={PocTaboolaSuffixId.ottMidSeriesWidget}
        index={counter}
      />
    </OttTaboolaWrap>
  )
}

export const OttTaboolaMidLiveWidget = () => {
  return (
    <OttTaboolaWrap>
      <Taboola
        pageType={PocTaboolaPageType.ott}
        suffixId={PocTaboolaSuffixId.ottMidLiveWidget}
      />
    </OttTaboolaWrap>
  )
}

interface OttTaboolaProgramItemWidgetProps {
  counter?: number
}

export const OttTaboolaProgramItemWidget = ({
  counter,
}: OttTaboolaProgramItemWidgetProps) => {
  if (!counter) {
    return null
  }
  return (
    <OttTaboolaProgramItemWidgetContainer>
      {Array.from({ length: counter }).map((_, i) => (
        <Taboola
          key={i}
          pageType={PocTaboolaPageType.ott}
          suffixId={PocTaboolaSuffixId.programItemLeftRailWidget}
          index={i}
        />
      ))}
    </OttTaboolaProgramItemWidgetContainer>
  )
}
export const OttTaboolaYouMightAlsoLikeWidget = () => {
  return (
    <OttTaboolaWrap>
      <Taboola
        pageType={PocTaboolaPageType.ott}
        suffixId={PocTaboolaSuffixId.ottMidLiveWidget}
      />
    </OttTaboolaWrap>
  )
}

export const OttTaboolaClipPageLeftRailWidget = () => {
  return (
    <OttTaboolaWrap>
      <Taboola
        pageType={PocTaboolaPageType.ott}
        suffixId={PocTaboolaSuffixId.clipPageLeftRailWidget}
      />
    </OttTaboolaWrap>
  )
}

interface ClipPageBetweenEpisodesWidgetProps {
  taboolaWidgetCounter?: number
}

export const ClipPageBetweenEpisodesWidget = ({
  taboolaWidgetCounter,
}: ClipPageBetweenEpisodesWidgetProps) => {
  const [shuldRender, setShulRender] = React.useState(false)

  useEffect(() => {
    isDesktop() && setShulRender(true)
  }, [])

  if (!shuldRender) {
    return null
  }

  return (
    <div style={{ gridColumn: '1 / -1', width: '100%' }}>
      <OttTaboolaWrap>
        <Taboola
          pageType={PocTaboolaPageType.ott}
          suffixId={PocTaboolaSuffixId.clipPageBetweenEpisodesWidget}
          index={taboolaWidgetCounter}
        />
      </OttTaboolaWrap>
    </div>
  )
}
